import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { ProductManualRoutesApplication, VersionRoutesApplication } from '../../constants';

function setupDataEntry(): void {
  applicationModuleRegistry.registerGroup({
    entry: 'data-entry',
    id: 'data-entry',
    modules: [
      {
        closeable: true,
        id: 'product-manual',
        entry: 'product-manual',
        name: 'modules.product-manual',
        route: ProductManualRoutesApplication.PRODUCT_MANUAL,
      },
      {
        closeable: true,
        entry: 'version',
        id: 'version',
        name: 'modules.version',
        route: VersionRoutesApplication.VERSION_LIST,
      },
    ],
    name: 'Downloads',
  });
}

export {
  setupDataEntry,
};
